import React from "react"
export function FlightDelay(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M13.375 8.278a4.868 4.868 0 014.875 4.86A4.868 4.868 0 0113.375 18 4.868 4.868 0 018.5 13.139a4.868 4.868 0 014.875-4.861zm0 .911a3.955 3.955 0 00-3.96 3.95 3.955 3.955 0 003.96 3.95 3.955 3.955 0 003.961-3.95 3.955 3.955 0 00-3.96-3.95zm.457 1.538v1.956h1.385v.912h-1.842a.457.457 0 01-.453-.394l-.004-.062v-2.412h.914zm3.824-7.37c.56.967.105 1.992-.954 2.65l-.112.068-1.593.917-.457-.79 1.593-.917c.75-.432 1.014-.984.731-1.473-.27-.465-.837-.531-1.538-.163l-.106.058-4.001 2.304a.458.458 0 01-.358.042l-.058-.021-4.24-1.9-.521.299 2.417 2.517a.455.455 0 01-.05.675l-.051.035L4.86 9.67a.458.458 0 01-.368.04l-.06-.025L1.743 8.39l-.538.305 3.302 3.286 2.871-1.653.457.789-3.174 1.828a.458.458 0 01-.5-.028l-.052-.044L.134 8.917a.455.455 0 01.047-.686l.05-.032 1.267-.72a.458.458 0 01.366-.039l.06.024 2.69 1.297 2.782-1.602L4.98 4.642a.455.455 0 01.05-.676l.052-.034 1.227-.707a.458.458 0 01.358-.043l.058.022 4.24 1.9 3.799-2.186c1.138-.656 2.313-.562 2.893.439z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__flight-delay"
        />
      </g>
    </svg>
  )
}
